import {useEffect} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {Link} from "react-router-dom";
import {ThinArrowLeft, ThinChatUnreadIcon, ThinPersonInformationIcon} from "../../../components/icons/material-icons";

export const AdminsConsultOverviewScreen = () => {
    useEffect(() => {
        document.title = "مشاور | اتوماسیون";
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مشاوره', url: '/admins/consult'},
            ]}/>
            <div className="acc-main-hero" data-mode={"consult"}>
                <div style={{backgroundImage: `url(/svg/consult.svg)`}} data-size={100}>
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        {/*<div className="acc-main-hero-effect1"/>*/}
                        {/*<div className="acc-main-hero-effect2"/>*/}
                        {/*<div className="acc-main-hero-effect3"/>*/}
                        {/*<div className="acc-main-hero-effect4"/>*/}
                        <b>
                            <i/>
                            <em/>
                            مشاوره
                        </b>
                        <p>مدیریت جامع بخش مشاوره آموزشگاه.</p>
                    </div>
                </div>
            </div>
            <div className="container" data-aos={"fade-up"} data-aos-duration={1000} data-aos-delay={200}>
                <div className="acc-main-buttons">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6">
                            <Link to={"requests"}>
                                <i><ThinChatUnreadIcon/></i>
                                <div>
                                    <b>درخواست‌های مشاوره</b>
                                    <span>درخواست‌های مشاوره توسط والدین.</span>
                                </div>
                                <em><ThinArrowLeft/></em>
                            </Link>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <Link to={"profiles"}>
                                <i><ThinPersonInformationIcon/></i>
                                <div>
                                    <b>فرم‌های اطلاعات</b>
                                    <span>فرم اطلاعات تکمیل شده توسط والدین.</span>
                                </div>
                                <em><ThinArrowLeft/></em>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};